import { HelloMuiButton } from 'components/Mui';
import { useModals } from 'pages/MainProvider';

interface Props {
    headerText: string;

    children: React.ReactNode;
}
const CompetitorAdjusted = ({ headerText, children }: Props) => {
    const { showSelectCompetitorModal } = useModals();
    return (
        <div className="bg-white py-[30px]">
            <div className="mx-auto w-fit max-w-[550px] bg-white px-[44px] pt-[60px] pb-[40px] text-center leading-[24px] flex flex-col gap-[20px] rounded-[10px]">
                <div>
                    <img alt={'Plan Limited'} src="/image/Plan-Limited.png" className="mx-auto" />
                    <div className="font-semibold text-[16px] pt-[20px]">{headerText}</div>
                    {children}
                </div>

                <HelloMuiButton variant="outlined" className="!h-[42px]" onClick={showSelectCompetitorModal}>
                    Manage Collaboration Partners
                </HelloMuiButton>
            </div>
        </div>
    );
};

export const NoCompetitor = () => {
    return (
        <CompetitorAdjusted headerText="No competitors selected.">
            <div>To view partner data, please select at least one collaboration partner.</div>
        </CompetitorAdjusted>
    );
};
